// extracted by mini-css-extract-plugin
export default {"callsWrapper":"Calls_callsWrapper__zvXeO","divider":"Calls_divider__CSCO4","noData":"Calls_noData__Uoxn2"};